export const ROUTES = {
  address: "/:signUpUUID?",
  planDetails: "/plan-details",
  details: "/details",
  payment: "/payment",
  success: "/success",
};
